'use client';

import type { CSSProperties, MouseEvent, ReactNode } from 'react';
import {
  resolveItemLinkRender,
  type PaintContext,
} from './viewingChromeHelpers';

export function ItemHrefControl({
  itemRef,
  paintContext,
  style,
  children,
  nodeType,
  dataTitleLinkOut,
}: {
  itemRef: string;
  paintContext?: PaintContext;
  style?: CSSProperties;
  children: ReactNode;
  nodeType?: string;
  dataTitleLinkOut?: boolean;
}) {
  const render = resolveItemLinkRender(itemRef, paintContext);
  const stop = (e: MouseEvent) => {
    e.stopPropagation();
  };
  const titleAttr = dataTitleLinkOut ? '1' : undefined;

  if (render.mode === 'anchor') {
    return (
      <a
        href={render.href}
        target={render.target}
        rel={render.rel}
        style={style}
        data-node={nodeType}
        data-href-link="1"
        data-item-ref={itemRef}
        data-title-link-out={titleAttr}
        onClick={stop}
      >
        {children}
      </a>
    );
  }

  const buttonStyle: CSSProperties = {
    ...style,
    cursor: 'pointer',
    font: style?.font ?? 'inherit',
    padding: style?.padding ?? 0,
    margin: style?.margin ?? 0,
    appearance: 'none',
    WebkitAppearance: 'none',
  };
  if (buttonStyle.background == null && buttonStyle.backgroundColor == null) {
    buttonStyle.background = 'transparent';
  }
  const width = buttonStyle.borderWidth;
  const noWidth =
    width == null || width === 0 || width === '0' || width === '0px';
  if (buttonStyle.border == null && noWidth) {
    buttonStyle.border = 'none';
  }

  return (
    <button
      type="button"
      style={buttonStyle}
      data-node={nodeType}
      data-href-link="1"
      data-item-ref={itemRef}
      data-title-link-out={titleAttr}
      onClick={(e) => {
        stop(e);
        paintContext?.onItemLinkNavigate?.(itemRef);
      }}
    >
      {children}
    </button>
  );
}
